'use client';

import LandingPageRevamped from './landing/LandingPageRevamped';
import LandingPageV2 from './landing/LandingPageV2';

/**
 * Client component for rendering landing page content
 * Separated from page.js to keep metadata export at server level
 */
export default function HomeContent() {
  const USE_V2 = true;
  return USE_V2 ? <LandingPageV2 /> : <LandingPageRevamped />;
}
